export default class ColorCommand {
  /**
   * Constructor
   */
  constructor(target, newColor) {
    this.label = 'Color'
    this.element = target
    this.newColor = newColor
    this.oldColor = target.fill
  }

  /**
   * applique les changement
   *
   * @memberof ColorCommand
   */
  execute() {
    const color = {
      fill: this.newColor
    }
    if (this.element.type === 'textbox') {
      if (this.element.selectionEnd - this.element.selectionStart !== 0) {
        this.element.setSelectionStyles(color, this.element.selectionStart, this.element.selectionEnd)
      } else {
        // reset du style de text
        this.element.set({ styles: { fill: null } })
        this.element.set(color)
      }
    } else {
      this.element.set(color)
    }
  }
  /**
   * supprime les changements
   *
   * @memberof ColorCommand
   */
  undo() {
    this.element.set({
      fill: this.oldColor
    })
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/ColorCommand.js